<template>
  <v-container>
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      />
    </v-overlay>
    <v-card
      width="100%"
      v-show="!overlay && isDataLoaded"
    >
      <v-card-title>
        <v-row>
          <v-col cols="6">
            <v-select
              v-model="selectedReportType"
              :items="reportTypes"
              item-text="label"
              item-value="key"
              label="Select Report Type"
              outlined
              hide-details
              return-object
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text v-if="selectedReportType">
        <component
          :is="selectedReportType.component"
          :params="selectedReportType.params"
        />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import KeyVehicleAllocation from "@/reports/KeyVehicleAllocation";
import UserBookingDetailsVue from './UserBookingDetails.vue';
import VehicleBookingDetailsVue from './VehicleBookingDetails.vue';
import AssetGroupBookingDetailsVue from './AssetGroupBookingDetails.vue';
import FBT from './FBT.vue';
import Booking from './Booking.vue';
import Utilisation from './Utilisation.vue';
import LateReturningKey from './LateReturningKey.vue';

export default {
  data() {
    return {
      overlay: false,
      isDataLoaded: false,
      isLoading: {
        users: true,
        assetGroups: true,
        assetTypes: true,
        assets: true,
        vehicles: true,
      },
      users: [],
      assetGroups: [],
      assetTypes: [],
      assets: [],
      vehicles: [],
      reportTypes: [
        {
          key: 'key_vehicle_allocation',
          label: 'Cabinet Key Item Allocation',
          component: KeyVehicleAllocation,
          params: {
            cabinets: [],
            assets: [],
            vehicles: [],
          },
        },
        {
          key: 'user_booking_details',
          label: 'User Booking Details',
          component: UserBookingDetailsVue,
          params: {
            users: [],
            assetTypes: [],
            geofences: [],
          },
        },
        {
          key: 'vehicle_booking_details',
          label: 'Vehicle Booking Details',
          component: VehicleBookingDetailsVue,
          params: {
            users: [],
            vehicles: [],
            assetGroups: [],
            assetTypes: [],
            geofences: [],
          },
        },
        {
          key: 'asset_group_booking_details',
          label: 'Asset Group Booking Details',
          component: AssetGroupBookingDetailsVue,
          params: {
            assetGroups: [],
            assetTypes: [],
          },
        },
        {
          key: 'fbt',
          label: 'FBT Report',
          component: FBT,
          params: {
            users: [],
            vehicles: [],
            assetGroups: [],
            assetTypes: [],
            geofences: [],
          },
        },
        {
          key: 'booking',
          label: 'Booking Report',
          component: Booking,
          params: {
            users: [],
            vehicles: [],
            assetGroups: [],
            assetTypes: [],
            geofences: [],
          },
        },
        {
          key: 'utilisation',
          label: 'Utilisation Report',
          component: Utilisation,
          params: {
            users: [],
            vehicles: [],
            assetGroups: [],
            assetTypes: [],
            geofences: [],
          },
        },
        {
          key: 'late_returning_key',
          label: 'Late Returning Key Report',
          component: LateReturningKey,
          params: {
            users: [],
            vehicles: [],
            assetGroups: [],  
            assetTypes: [],
            geofences: [],
          }, 
        },
      ],
      selectedReportType: "",
    };
  },
  created() {
    this.overlay = true;
    Promise.all([
      this.$store.dispatch("GET_GEOFENCES"),
      this.$store.dispatch("LOAD_CABINETS"),
      this.getDataUsers(),
      this.getDataAssetTypes(),
      this.getDataAssets(),
      this.getDataVehicles()
    ]).then(() => {
      this.getDataVehicleGroups();
      this.updateReportTypesWithGeofences();
      this.updateReportTypesWithCabinets();
    }).catch(error => {
      console.error('Error loading data:', error);
      this.overlay = false;
    });
  },
  computed: {
    geofences() {
      return this.$store.getters["getGeofencesData"];
    },
  },
  methods: {
    updateReportTypesWithGeofences() {
      this.reportTypes = this.reportTypes.map((reportType) => {
        if (reportType.params.hasOwnProperty('geofences')) {
          return {
            ...reportType,
            params: {
              ...reportType.params,
              geofences: this.geofences
            }
          };
        }
        return reportType;
      });
    },
    updateReportTypesWithCabinets() {
      this.reportTypes = this.reportTypes.map((reportType) => {
        if (reportType.params.hasOwnProperty('cabinets')) {
          return {
            ...reportType,
            params: {
              ...reportType.params,
              cabinets: this.$store.getters["getCabinets"]
            }
          };
        }
        return reportType;
      });
    },
    getValueAsBoolean(value) {
      return value == 1 || value == '1' || value == 'true' || value == true ? 1 : 0;
    },
    getDataVehicleGroups() {
      if (this.isLoading.vehicles && this.isLoading.users && this.isLoading.assets) {
        setTimeout(() => {
          this.getDataVehicleGroups();
        }, 1000);
        return;
      }
      this.isLoading.assetGroups = true;
      this.$store
        .dispatch("API_CALL", {
          $method: "get_asset_groups_booking",
          $postData: {
            clientid: this.$store.state.clientid,
            show_detail: 0
          }
        })
        .then(response => {
          const vehiclesById = new Map(this.vehicles.map(v => [v.id.toString(), v]));
          const usersById = new Map(this.users.map(u => [u.id.toString(), u]));

          this.assetGroups = response.data.data
            .filter(group => {
              const noBookingRequired = this.getValueAsBoolean(group.metadata.no_booking_required);
              const isSpecial = this.getValueAsBoolean(group.metadata.is_special);
              return !noBookingRequired && !isSpecial;
            })
            .map(group => {
              const memberIds = (group.group_member_id || []).map(id => id.toString());
              const userIds = (group.group_user_id || []).map(id => id.toString());

              return {
                ...group,
                members: memberIds
                  .map(id => vehiclesById.get(id))
                  .filter(Boolean)
                  .map(vehicle => ({ detail: vehicle })),

                users: userIds
                  .map(id => usersById.get(id))
                  .filter(Boolean)
                  .map(user => ({
                    user_id: user.id,
                    name: user.name,
                    email: user.email,
                    type: user.type
                  }))
              };
            });

          this.reportTypes = this.reportTypes.map(reportType => {
            if (reportType.params.assetGroups !== undefined) {
              return {
                ...reportType,
                params: {
                  ...reportType.params,
                  assetGroups: this.assetGroups
                }
              };
            }
            return reportType;
          });
          
          this.isDataLoaded = true;
          this.isLoading.assetGroups = false;
          this.overlay = false;
        });
    },
    getDataAssetTypes() {
      return this.$store.dispatch('API_CALL', {
        $method: 'get_asset_types',
        $postData: {
          clientid: this.$store.state.clientid,
        },
      })
      .then((response) => {
        this.isLoading.assetTypes = false;
        this.assetTypes = response.data.data;
        this.reportTypes = this.reportTypes.map((reportType) => {
          if (reportType.params.hasOwnProperty('assetTypes')) {
            return {
              ...reportType,
              params: {
                ...reportType.params,
                assetTypes: this.assetTypes
              }
            };
          }
          return reportType;
        });
      });
    },
    getDataAssets() {
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_assets",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.isLoading.assets = false;
          this.assets = response.data.data;
          this.reportTypes = this.reportTypes.map((reportType) => {
            if (reportType.params.hasOwnProperty('assets')) {
              return {
                ...reportType,
                params: {
                  ...reportType.params,
                  assets: this.assets
                }
              };
            }
            return reportType;
          });
        });
    },
    getDataVehicles() {
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_vehicles",
          $postData: {
            clientid: this.$store.state.clientid
          }
        })
        .then(response => {
          this.isLoading.vehicles = false;
          this.vehicles = response.data.data;
          this.reportTypes = this.reportTypes.map((reportType) => {
            if (reportType.params.hasOwnProperty('vehicles')) {
              return {
                ...reportType,
                params: {
                  ...reportType.params,
                  vehicles: this.vehicles
                }
              };
            }
            return reportType;
          });
        });
    },
    getDataUsers() {
      return this.$store
        .dispatch("API_CALL", {
          $method: "get_all",
          $postData: {
            clientid: this.$store.state.clientid,
            get_groups: 0
          }
        })
        .then(response => {
          this.isLoading.users = false;
          this.users = response.data.data;
          this.reportTypes = this.reportTypes.map((reportType) => {
            if (reportType.params.hasOwnProperty('users')) {
              return {
                ...reportType,
                params: {
                  ...reportType.params,
                  users: this.users
                }
              };
            }
            return reportType;
          });
        });
    },
  },
};
</script>
